import { render, staticRenderFns } from "./WeightsBlock.vue?vue&type=template&id=198e71f6&lang=pug&"
import script from "./WeightsBlock.vue?vue&type=script&lang=js&"
export * from "./WeightsBlock.vue?vue&type=script&lang=js&"
import style0 from "./WeightsBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports